import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useDocumentTitle } from '@/hooks';
import { useLocale } from '@/lib/i18n';
import { AuthBrandPanel } from './AuthBrandPanel';

interface AuthLayoutProps {
  title: string;
  children: ReactNode;
}

/** Two-column auth shell: branded panel (lg+) + form card. Mobile shows form only. */
export function AuthLayout({ title, children }: AuthLayoutProps) {
  useDocumentTitle(title);
  const { direction } = useLocale();
  const isRTL = direction === 'rtl';

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-surface-base">
      <div className="relative flex items-center justify-center px-4 py-10 sm:px-8">
        {/* Mobile-only brand mark */}
        <Link
          to="/"
          className="absolute top-6 flex items-center gap-2 lg:hidden"
          style={{ [isRTL ? 'right' : 'left']: '1.5rem' }}
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-surface-card border border-surface-border text-accent">
            <ShieldCheck size={16} />
          </div>
          <span className="font-display text-xl text-brand-white">Playerso</span>
        </Link>

        <div className="w-full max-w-md mt-12 lg:mt-0">{children}</div>
      </div>

      <AuthBrandPanel />
    </div>
  );
}